<template>
<div class="input__wrapper">
  <p class="lineBreakView"></p>
   <DeleteButton :index="index" />
</div> 
</template>

<script setup>
import DeleteButton from '@/components/PopUp/DeleteButton.vue'
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String,
    index:Number
})

const imgSrc = fieldFactory('imgSrc', props.popStoreId)
</script>

<style>

</style>